import api, { ValidateAxiosError } from '@/modules/api.service';
import { CreateCursoDto, ReadCursoDto, UpdateCursoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { SearchDto } from '@/shared/types/search.dto';

export class CursoService {
  async create(obj: CreateCursoDto): Promise<number> {
    try {
      return (await api.post(Endpoints.CURSO, obj)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao cadastrar curso.');
    }
  }

  async findOne(id: number): Promise<ReadCursoDto> {
    try {
      const response = await api.get(Endpoints.CURSO + '/' + id);
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao bucar o curso." + id');
    }
  }

  async update(id: number, dto: UpdateCursoDto): Promise<void> {
    try {
      return (await api.put(Endpoints.CURSO + '/' + id, dto)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao atualizar curso.');
    }
  }

  async remove(id: number): Promise<void> {
    try {
      return await api.delete(Endpoints.CURSO + '/' + id);
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao remover curso.');
    }
  }

  async findAll(conditions: SearchDto): Promise<[ReadCursoDto[], number]> {
    try {
      const response = await api.get(Endpoints.CURSO, {
        params: { skip: conditions.skip, take: conditions.take },
      });
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar cursos.');
    }
  }

  async findAllPublic(conditions: SearchDto): Promise<[ReadCursoDto[], number]> {
    try {
      const response = await api.get(Endpoints.CURSO + '/public/all', {
        params: { skip: conditions.skip, take: conditions.take },
      });
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar cursos.');
    }
  }
}
